import { createComponent, createHook } from "reakit-system";
import type { ColorProps, TypographyProps } from "styled-system";
import { color, compose, system, typography } from "styled-system";
import type { Property } from "csstype";
import type { Theme } from "@mos-cat/ds-theme";
import type { StylesOptions } from "../hooks/useStyles";
import { useStyles } from "../hooks/useStyles";
import { useTheme } from "../hooks/useTheme";
import { cx, ecss } from "../reexports/emotion";
import type { BoxHTMLProps } from "../Box/Box";

const textDecoration = system({
  textDecoration: true,
});
const WebkitTextFillColor = system({
  WebkitTextFillColor: {
    property: "WebkitTextFillColor",
    scale: "colors",
  },
});
let textScales = compose(typography, color, textDecoration, WebkitTextFillColor);

export type TextOptions = TypographyProps<Theme> &
  ColorProps<Theme> & {
    textDecoration?: Property.TextDecoration;
    WebkitTextFillColor?: Property.WebkitTextFillColor;
  } & StylesOptions;

export type TextHTMLProps = Omit<BoxHTMLProps, "color">;

export type TextProps = TextOptions & TextHTMLProps;

export let useText = createHook<TextOptions, TextHTMLProps>({
  name: "Text",
  keys: textScales.propNames,
  compose: [useStyles, useTheme],
  useProps(options, props) {
    return {
      ...props,
      className: cx(props.className, ecss({ label: "Text" }, textScales(options))),
    };
  },
});

export let Text = createComponent<"span", TextOptions>({
  as: "span",
  useHook: useText,
  memo: true,
});
